// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import { createStore } from './store'
import { getParam } from './lib/Params'

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueSlider from 'vue-slider-component'
import customIcons from './data/custom_icons.json'
import locales from './data/locales.json'
import Modal from './components/Modal'
import ModalMenu from './components/ModalMenu'

Vue.component('icon', Icon)
Vue.component('vue-slider', VueSlider)
Vue.component('modal', Modal)
Vue.component('modal-menu', ModalMenu)

Vue.mixin({
  data () {
    return {
      get canCloseApp () {
        return !!window.opener
      }
    }
  },

  methods: {
    closeApp () {
      return window.close()
    }
  }
})

Icon.register(customIcons)

Vue.config.productionTip = false

Vue.use(VueI18n)

const i18n = new VueI18n({
  // Get locale from query parameter.
  locale: getParam('locale') || navigator.language,
  fallbackLocale: {
    'fr': ['fr-CA'],
    'ca-ES': ['es-ES'],
    'eu-ES': ['es-ES'],
    'gl-ES': ['es-ES'],
    default: ['en-CA']
  },
  // Need this to disable warn message when fallbacking to fallbacklocale
  silentTranslationWarn: true,
  messages: locales
})

const store = createStore(getParam('pid'), getParam('sid'))

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js